export default {"src":"/_next/static/image/public/images/ic_blue_incomplete_circle.3140727f109b1bf63b2138d24d72c9d7.svg","height":30,"width":30};